import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import type VotingSessionWidget from '../../../widgets/VotingSessionWidget';
import VotingSessionController from './controllers/VotingSessionController';
import { PokerCard } from './PokerCard';
import { votingObjectIcon } from './Result';
import styles from './VotingSession.module.css';
import classNames from 'classnames';

export const PokerVotingSessionResults = ({
  widget,
  showHeader,
}: {
  widget: VotingSessionWidget;
  showHeader: boolean;
}) => {
  const controller = useController(VotingSessionController);
  const finalScores = widget.pokerFinalScores;
  if (!finalScores) {
    return <></>;
  }
  return (
    <div
      className={classNames(
        styles.pokerPreviousResultsContainer,
        showHeader ? 'mt-12' : null
      )}
    >
      {showHeader && (
        <span className='color-tertiary t-100'>Previous estimates</span>
      )}
      {Object.entries(finalScores).map(([recordId, score]) => {
        const shape = controller.getShapeByRecordId(recordId);
        if (!shape) {
          return null;
        }
        return (
          <div key={recordId} className={styles.pokerPreviousResult}>
            {votingObjectIcon(shape)}
            <span className='grow gap-2 t-100 color-tertiary'>
              {shape.plainText()}
            </span>
            <PokerCard cardSize='small' cardColor='normal' value={score} />
          </div>
        );
      })}
    </div>
  );
};

export default ApplicationView(PokerVotingSessionResults);
